import { render, staticRenderFns } from "./ImagePreviewComponent.vue?vue&type=template&id=339ddd4b&scoped=true"
import script from "./ImagePreviewComponent.vue?vue&type=script&lang=js"
export * from "./ImagePreviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewComponent.vue?vue&type=style&index=0&id=339ddd4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ddd4b",
  null
  
)

export default component.exports